import { deleteToken, getToken, isSupported, onMessage } from 'firebase/messaging';
import { Timestamp } from 'firebase/firestore';
import { createPushClient, firebaseMessagingAdapter, firestoreTokenStore } from '@kilat/ui';

import { messaging } from '../firebase.js';
import { env } from '../env.js';
import { logger } from '../logger.js';
import { fcmTokensRepoFor } from '../repositories/fcm-tokens-repo.js';

/**
 * Agent push client — the shared @kilat/ui plumbing bound to this app's
 * Firebase. No React: use-auth.tsx calls `cleanupForSignOut` before it
 * switches users.
 */
export const agentPushClient = createPushClient({
  messaging: firebaseMessagingAdapter(
    { isSupported, getToken, deleteToken, onMessage },
    messaging,
    env.fcmVapidKey,
  ),
  tokens: firestoreTokenStore({
    repoFor: fcmTokensRepoFor,
    now: () => Timestamp.now(),
    fromParts: (seconds, nanoseconds) => new Timestamp(seconds, nanoseconds),
  }),
  logger,
  vapidKeyPresent: Boolean(env.fcmVapidKey),
  appBase: '/',
});
